export default {
    state: {
        editFoodRestrictionMenu: {
            isVisible: false
        },
        addRestrictionMenu: {
            isVisible: false
        },
        restrictionProdModal: {
            isVisible: false
        }
    },
    mutations: {
        setEditRestrictionMenuVisibility (state) {
            state.editFoodRestrictionMenu.isVisible =
                !state.editFoodRestrictionMenu.isVisible
        },
        setAddRestrictionMenuVisibility (state) {
            state.addRestrictionMenu.isVisible =
                !state.addRestrictionMenu.isVisible
        },
        setRestrictionProdModalVisibility (state) {
            state.restrictionProdModal.isVisible =
                !state.restrictionProdModal.isVisible
        }
    },
    actions: {
        changeEditRestrictionMenuVisibility ({ commit }) {
            commit('setEditRestrictionMenuVisibility')
        },
        changeAddRestrictionMenuVisibility ({ commit }) {
            commit('setAddRestrictionMenuVisibility')
        },
        changeRestrictionProdModalVisibility ({ commit }) {
            commit('setRestrictionProdModalVisibility')
        }
    },
    getters: {
        editFoodRestrictionMenu: (state) => state.editFoodRestrictionMenu,
        addRestrictionMenu: (state) => state.addRestrictionMenu,
        restrictionProdModal: (state) => state.restrictionProdModal
    }
}
